import { jsxs, jsx } from "react/jsx-runtime";
import { isValidElement } from "react";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Icon } from "../../../foundations/icons/Icon.js";
import { Text, P } from "../../../foundations/typography/Text/Text.js";
const message = "_message_cdxce_1";
const messageMain = "_messageMain_cdxce_13";
const messageContent = "_messageContent_cdxce_20";
const messageTitle = "_messageTitle_cdxce_21";
const styles = {
  message,
  messageMain,
  messageContent,
  messageTitle,
  "message-info": "_message-info_cdxce_29",
  "message-neutral": "_message-neutral_cdxce_35"
};
const Message = ({
  children,
  className,
  icon,
  titleHeadingLevel,
  title,
  variant = "info",
  ...props
}) => {
  return /* @__PURE__ */ jsxs("div", { className: clsx(styles.message, styles["message-" + variant], className), ...props, children: [
    icon && /* @__PURE__ */ jsx(Icon, { variant: icon, "aria-hidden": "true" }),
    /* @__PURE__ */ jsxs("div", { className: styles.messageMain, children: [
      title && /* @__PURE__ */ jsx(
        Text,
        {
          variant: "text-body-head",
          className: styles.messageTitle,
          component: titleHeadingLevel || "h3",
          children: title
        }
      ),
      children && (isValidElement(children) ? children : /* @__PURE__ */ jsx(P, { className: styles.messageContent, children }))
    ] })
  ] });
};
export {
  Message
};
